"use client";

import { ArrowRight, FileText, ShieldCheck, Scale, List, Scale as Balance } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function KlarifikasiHero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: metaRef,
    isVisible: metaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const dataPoints = [{
    label: "AKURASI",
    value: "100%"
  }, {
    label: "KECEPATAN",
    value: "REALTIME"
  }, {
    label: "VERIFIKASI",
    value: "RESMI"
  }];
  const badges = [{
    label: "Sesuai UU Pers",
    icon: Scale
  }, {
    label: "Berimbang",
    icon: Balance
  }, {
    label: "Terverifikasi",
    icon: ShieldCheck
  }];
  return <section data-section-id="3626" id="klarifikasihero" className="bg-white text-black relative min-h-[80vh] lg:min-h-screen w-full overflow-hidden flex items-center">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_50%,rgba(235,124,45,0.05),transparent_50%)]" />
      
      {}
      <div className="absolute top-1/4 left-10 opacity-20 hidden lg:block">
        <div className="grid grid-cols-2 gap-2">
          {[...Array(12)].map((_, i) => <div key={i} className="size-1 bg-gray-400 rounded-lg" />)}
        </div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-[1400px] px-6 py-20 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
          
          {}
          <div ref={headlineRef} className={`col-span-1 lg:col-span-7 flex flex-col transition-all duration-1000 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h1 className="font-sans font-bold text-5xl md:text-7xl lg:text-8xl text-black tracking-tight mb-6">
              Klarifikasi
            </h1>

            <p className="font-sans text-lg md:text-xl text-gray-600 max-w-[600px] leading-relaxed mb-10">
              Ruang resmi <span className="font-bold text-black">ABADI.NEWS</span> untuk Klarifikasi Resmi, Cek Fakta, dan Hak Jawab secara terbuka, berimbang, dan bertanggung jawab.
            </p>

            {}
            <div className="flex flex-wrap gap-4 mb-12">
              {badges.map((badge, i) => <div key={badge.label} data-index={i} className="flex items-center gap-3 px-5 py-3 bg-gray-50 rounded-lg border border-gray-100 shadow-sm">
                  <badge.icon className="size-5 text-[#EB7C2D]" />
                  <span className="text-sm font-sans font-semibold text-gray-700">{badge.label}</span>
                </div>)}
            </div>

            {}
            <div className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center">
              <Button asChild size="lg" className="group h-14 px-8 bg-[#EB7C2D] text-white font-sans font-bold text-base shadow-md hover:bg-[#EB7C2D]/90 transition-all duration-300 rounded-lg">
                <Link to="/AnswerRightsPage">
                  <FileText className="mr-2 size-5" />
                  Ajukan Klarifikasi
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="h-14 px-8 bg-white border-2 border-[#EB7C2D] text-[#EB7C2D] font-sans font-bold text-base hover:bg-orange-50 transition-all duration-300 rounded-lg">
                <Link to="/ClarificationPage">
                  <List className="mr-2 size-5" />
                  Lihat Klarifikasi Terbaru
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={metaRef} className={`col-span-1 lg:col-span-5 flex items-center justify-center transition-all duration-1000 delay-300 ease-out ${metaVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
            <div className="relative w-full max-w-[500px]">
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/klarifikasi_illustration.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/klarifikasi_illustration.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/klarifikasi_illustration.png-wvc-sizes" alt="Klarifikasi Illustration" className="w-full h-auto relative z-10" loading="lazy" />
              
              {}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 size-[120%] bg-orange-50 rounded-lg -z-0 blur-3xl opacity-50" />
              
              {}
              <div className="absolute -right-4 top-1/2 -translate-y-1/2 opacity-40">
                <div className="grid grid-cols-2 gap-2">
                  {[...Array(10)].map((_, i) => <div key={i} className="size-1 bg-[#EB7C2D] rounded-lg" />)}
                </div>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="mt-20 pt-10 border-t border-gray-100">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
            {dataPoints.map((point, i) => <div data-index={i} key={point.label} className="flex flex-col gap-1">
                <span className="font-sans text-xs uppercase tracking-widest text-gray-400 font-bold">
                  {point.label}
                </span>
                <span className="font-sans font-black text-2xl text-black">
                  {point.value}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}